// extracted by mini-css-extract-plugin
module.exports = {"userRatingContainer":"UserRating_userRatingContainer__1NkIN","filled":"UserRating_filled__3Y3C1","empty":"UserRating_empty__2WCk6"};